// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/*\n  SCSS Variables Files\n\n  This file should be imported to all components that need to access the SCSS Variables for themeing\n  It *SHOULD NOT* contain any CSS Rules. Only Variables.\n  Global Styles should be added to the custom.scss file, which is imported globally and applied to all components\n  automatically.\n */", ""]);
// Exports
module.exports = exports;
